import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Method } from './components/Method';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Tools } from './components/Tools';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-navy" data-id="element-0" data-mp="23vcikoy874a1">
      <MetaPixel data-id="element-1" data-mp="23t8g8bfz6dbv" />
      <Hero data-id="element-2" data-mp="3ijxo6nd1puib" />
      <main data-id="element-3" data-mp="3ikh8gaq64uzi">
        <Method data-id="element-4" data-mp="3ikqy1x7ax04o" />
        <BeforeAfter data-id="element-5" data-mp="3ij66mgga9xb1" />
        <PainPoints data-id="element-6" data-mp="3ijpet5g4t7bv" />
        <Volumes data-id="element-7" data-mp="3mlj9mx3nbh44" />
        <Tools data-id="element-8" data-mp="3ml14faz09sk2" />
        <Bonuses data-id="element-9" data-mp="3mkrgru1fnxhj" />
        <Offer data-id="element-10" data-mp="3mk83wrqn3zad" />
        <Guarantee data-id="element-11" data-mp="3mjq45l4rr2xp" />
        <Testimonials data-id="element-12" data-mp="3mj6lu3b7icj5" />
        <About data-id="element-13" data-mp="3rbrayrj641gc" />
        <Faq data-id="element-14" data-mp="3rdapodp6e4g0" />
        <FinalCta data-id="element-15" data-mp="3rdkl4gszp3t3" />
      </main>
      <Footer data-id="element-16" data-mp="3reltgdimfc74" />
      <FloatingCta data-id="element-17" data-mp="5yh2n2cyzbp" />
      <PurchasePopup data-id="element-18" data-mp="67z9oh5w26u" />
    </div>;
}